import { useMemo } from 'react'
import { useUserSession } from './useUserSession'
import { default as UUID } from 'uuid'
import { useCurrentUserQuery } from '@src/queries/CurrentUserQuery.generated'
enum ConfigProperties {
  LoggedInUser = 'LoggedInUser',
}
export const useLabWaterParticipantId = () => {
  const { userSession } = useUserSession()
  const { data } = useCurrentUserQuery({ context: { userSession } })
  return useMemo(() => {
    return data?.me && data?.me.__typename === ConfigProperties.LoggedInUser
      ? data?.me?.id
      : userSession.accessToken
        ? userSession.accessToken
        : UUID.v4()
  }, [])
}
